import React from 'react'
import { shallow } from 'enzyme'
import { AnswerEditor } from '../../modelEditors/AnswerEditor'

describe('AnswerEditor', () => {
  let wrapper, props, instance

  beforeAll( () => {
    props = {
      object: {
        __typename: 'Answer',
        rid: 1,
        value: '1,2',
        type: 'Answer::Enumerate',
        questionNumber: 700
      },
      helpers: {
        questions: [
          {
            number: 700,
            selectOptions: [
              ['label', '1']
            ]
          }
        ]
      },
      loan: {
        rid: 18
      }
    }
    wrapper = shallow(<AnswerEditor {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe('#question', () => {
    it('should return obj', () => {
      const { question } = instance

      expect(question.number).toBe(700)
    })
  })

  describe('#originalValue', () => {
    it('should return obj', () => {
      const { originalValue } = instance

      expect(originalValue).toBe('1,2')
    })
  })

  describe('#objectValue', () => {
    it('should return obj', () => {
      const { objectValue } = instance

      expect(objectValue.length).toBe(1)
    })
  })

  describe('#getSlitOptions', () => {
    it('should return array', () => {
      const arr = instance.getSlitOptions('1,2')

      expect(arr.length).toBe(2)
    })
  })

  describe('#getOptionsLabels', () => {
    it('should return array', () => {
      const arr = instance.getOptionsLabels()

      expect(arr.length).toBe(1)
    })
  })

  describe('#toggleEdition', () => {
    it('should return array', () => {
      instance.toggleEdition()

      expect(instance.state.editModeOn).toBeTruthy()
    })
  })

  describe('#toggleEditionCancel', () => {
    it('should return array', () => {
      const toggleEdition = spyOn(instance, 'toggleEdition')
      instance.toggleEditionCancel()

      expect(toggleEdition).toHaveBeenCalled()
    })
  })

  describe('#renderForm', () => {
    it('should return obj', () => {
      const { renderForm } = instance

      expect(renderForm()).toBeTruthy()
    })
  })

  describe('#renderStatic', () => {
    it('should return obj', () => {
      const { renderStatic } = instance

      expect(renderStatic()).toBeTruthy()
    })
  })

  describe('#renderEdit', () => {
    it('should return obj', () => {
      const { renderEdit } = instance

      expect(renderEdit()).toBeTruthy()
    })
  })

  describe('#onChange', () => {
    it('should set value', () => {
      instance.onChange({ target: { value: '1,3' }})

      expect(instance.state.value).toBe('1,3')
    })
  })

  describe('#onChangeCheckbox', () => {
    it('should set value', () => {
      instance.onChangeCheckbox({ target: { value: '4', checked: true }})

      expect(instance.state.value).toBe('1,3,4')
    })
  })

  describe('#onSubmit', () => {
    it('should return obj', async () => {
      const toggleEdition = spyOn(instance, 'toggleEdition')
      const _updateData = spyOn(instance, '_updateData')
      await instance.onSubmit({ preventDefault: () => true, stopPropagation: () => true })

      expect(toggleEdition).toHaveBeenCalled()
      expect(_updateData).toHaveBeenCalled()
    })
  })
})